import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SaveIcon from '../../themes/svg/saveIcon';
import { sites } from '../../helpers/globalVariables';
import getThdLoginUrl from '../../helpers/getThdLoginUrl';
import * as thdUser from '../../../common/thdUserInfo';
import config from '../../helpers/config';
import { createAndSendButtonSubmissionEventWithEventName } from '../../analytics/commonAnalytics';
import AnalyticsConstants from '../../analytics/constants';

class SaveIconButton extends Component {
  displayLoginModal = () => {
    const loginEvent = new CustomEvent('loginRequested', {
      detail: {
        taskName: 'estimate',
        redirectAfterCreate: false,
      },
    });

    document.dispatchEvent(loginEvent);

    document.addEventListener('loginStatusChange', (e) => {
      if (e.detail.isLoggedIn) {
        this.save();
      }
    });
  };

  save = () => {
    if (window.globalConfig.siteId === sites.theHomeDepot && !thdUser.isLoggedIn()) {
      createAndSendButtonSubmissionEventWithEventName(
        window.globalConfig.siteId,
        AnalyticsConstants.EventNames.DesignSave,
      );

      const fullPageLoginReturnPath = `${config.estimatebuilderBasePath}${config.estimatebuilderLoadPath}/${this.props.designId}`;
      const returnUrl = encodeURIComponent(encodeURIComponent(`${config.baseUrl}${config.estimatebuilderBasePath}${config.estimatebuilderLoadPath}/${this.props.designId}`));
      window.location.href = config.enableTHDFullPageLogin ? getThdLoginUrl(fullPageLoginReturnPath) : `${config.thdLoginPage}${returnUrl}`;
    } else {
      this.props.saveToMyAccount(this.props.designId).catch((e) => {
        if (e.response.status === 401) {
          this.displayLoginModal();
        } else {
          alert('Error saving estimate!'); // eslint-disable-line
        }
      });
    }
  }

  render() {
    return !this.props.isLinked && (
      <div className="action">
        <div
          className="save"
          tabIndex="-1"
          role="button"
          onClick={this.save}
        >
          <SaveIcon />{' '}
          <span id="saveEstimateButton" className="actionText">
            Save
          </span>
        </div>
      </div>
    );
  }
}

SaveIconButton.propTypes = {
  saveToMyAccount: PropTypes.func.isRequired,
  designId: PropTypes.string.isRequired,
  isLinked: PropTypes.bool,
};
SaveIconButton.defaultProps = {
  isLinked: false,
};

export default SaveIconButton;
